module.exports = __webpack_public_path__ + "media/bootstrap-icons/stickies-a09a5f6f.svg";